export default __webpack_public_path__ + "static/FinancialIncentiveZones-3a42f276c1283a7fd9c563b1e5d1a0b1.jpg";